import { CustomIconProps } from './art';

export const JobCalendarIcon = (props: CustomIconProps): JSX.Element => (
  <svg width="20" height="21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.817.456A.625.625 0 015 .898v.625h10V.898a.625.625 0 111.25 0v.625h1.25a2.5 2.5 0 012.5 2.5v1.25H0v-1.25a2.5 2.5 0 012.5-2.5h1.25V.898A.625.625 0 014.817.456zm8.415 11.15c0 .87-.698 1.475-1.48 1.475-.75 0-1.43-.48-1.43-1.5 0-1.03.728-1.513 1.46-1.513.792 0 1.45.498 1.45 1.538zM20 6.523v11.25a2.5 2.5 0 01-2.5 2.5h-15a2.5 2.5 0 01-2.5-2.5V6.523h20zM9.541 14.502c.059.8.742 1.759 2.129 1.759v-.002c1.572 0 2.5-1.332 2.5-3.588 0-2.418-.976-3.335-2.441-3.335-1.158 0-2.246.84-2.246 2.26 0 1.45 1.03 2.213 2.095 2.213.932 0 1.537-.47 1.728-.987h.034c-.005 1.645-.576 2.705-1.631 2.705-.83 0-1.26-.563-1.314-1.025h-.854zm-1.484 1.63V9.467h-.79c-.568.302-1.116.638-1.642 1.006v.87a21.98 21.98 0 011.572-.971h.016v5.76h.844z"
      fill="#259BE9"
    />
  </svg>
);
